/**
 * Modern Bold · <mb-layout-toggle> custom element
 * ─────────────────────────────────────────────────────────────────────────
 * Shopper-facing 1↔2 column switch for the mobile collection grid.
 * The merchant's "Columns on mobile" section setting renders the default;
 * a shopper's tap overrides it for THIS page view only. Nothing is
 * written to browser storage (per store owner's request) — the choice
 * lives in module state, which survives the AJAX filter pipeline's
 * innerHTML swap (this element reconnects and re-applies it) and resets
 * on a real navigation or reload.
 *
 * DOM contract (rendered by sections/main-collection-modern.liquid):
 *   <mb-layout-toggle>
 *     button[data-mb-cols="1"] / button[data-mb-cols="2"]   (aria-pressed)
 *   Grid: .mb-collection__grid inside the same [data-mb-collection] root;
 *   the --m1 modifier class = 1 column under 750px.
 */
if (!customElements.get('mb-layout-toggle')) {
  // Mirrors snippets/modern-collection-card.liquid — only the <750px tail
  // differs. Swapped on toggle so full-width cards pick the bigger files.
  const SIZES_1 = '(min-width: 990px) 25vw, (min-width: 750px) 50vw, 100vw';
  const SIZES_2 = '(min-width: 990px) 25vw, (min-width: 750px) 50vw, 50vw';

  // Page-lifetime choice — deliberately NOT persisted anywhere.
  let chosenCols = null;

  class MBLayoutToggle extends HTMLElement {
    #cleanups = [];
    #grid = null;

    connectedCallback() {
      this.#grid = this.closest('[data-mb-collection]')?.querySelector('.mb-collection__grid');
      if (!this.#grid) return;

      if (chosenCols) this.#apply(chosenCols);

      this.querySelectorAll('[data-mb-cols]').forEach((btn) => {
        const onClick = () => {
          chosenCols = btn.dataset.mbCols;
          this.#apply(chosenCols);
        };
        btn.addEventListener('click', onClick);
        this.#cleanups.push(() => btn.removeEventListener('click', onClick));
      });
    }

    disconnectedCallback() {
      this.#cleanups.forEach((fn) => fn());
      this.#cleanups = [];
    }

    #apply(cols) {
      this.#grid.classList.toggle('mb-collection__grid--m1', cols !== '2');
      this.querySelectorAll('[data-mb-cols]').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn.dataset.mbCols === cols));
      });
      const sizes = cols === '2' ? SIZES_2 : SIZES_1;
      this.#grid.querySelectorAll('.mb-colcard img').forEach((img) => {
        img.sizes = sizes;
      });
    }
  }

  customElements.define('mb-layout-toggle', MBLayoutToggle);
}
